import axios from 'axios';
import { constants } from '../../constants';

export const putUserRole = (role: string, chatroomId: string, userId: string) => {
  const token = localStorage.getItem('token');
  return axios.put(
    `${constants.endpoint}/users/role?newRole=${role}`, {
      chatroomId,
      userIds: [userId]
    },
    {
      headers: {
        Authorization: `bearer ${token}`,
      },
    }
  )
};
